import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const Retail = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const updatePurchaseProfile = { ...purchaseProfile, retail: { ...purchaseProfile.retail, [key]: value } }
    // dispatch(setNewPurchaseProfile(updatePurchaseProfile))
    dispatch(setLocal(props.PURCHASE_PROFILE, updatePurchaseProfile))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.yield-and-object-criteria.retail.share-of-fmcg.from']}</div>
        <div className="values">
          <Input
            type="number"
            suffix={translations['percent.symbol']}
            value={purchaseProfile.retail.shareOfFMCGFrom}
            onChange={update('shareOfFMCGFrom')}
            placeholder={translations['my-objects.pipeline.yield-and-object-criteria.retail.share-of-fmcg.from']}
          />
          <Input
            type="number"
            suffix={translations['percent.symbol']}
            value={purchaseProfile.retail.shareOfFMCGUntil}
            onChange={update('shareOfFMCGUntil')}
            placeholder={translations['my-objects.pipeline.yield-and-object-criteria.retail.share-of-fmcg.until']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.yield-and-object-criteria.retail.retail.from']}</div>
        <div className="values">
          <Input
            type="number"
            suffix={translations['percent.symbol']}
            value={purchaseProfile.retail.retailFrom}
            onChange={update('retailFrom')}
            placeholder={translations['my-objects.pipeline.yield-and-object-criteria.retail.retail.from']}
          />
          <Input
            type="number"
            suffix={translations['percent.symbol']}
            value={purchaseProfile.retail.retailUntil}
            onChange={update('retailUntil')}
            placeholder={translations['my-objects.pipeline.yield-and-object-criteria.retail.retail.until']}
          />
        </div>
      </div>
    </div>
  )
}

export default Retail
